export default "__VITE_ASSET__DlI79x$f__"